module.exports = __webpack_public_path__ + "img/bussniessImg.4b738d9c.png";